import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import { Prices } from '../components/Prices.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/shipping';

const PricesContainer = ({ className , discount , orientation , originalPrice , totalPrice  })=>{
    const { currency , getLabel  } = useIntl();
    const labels = {
        freeProduct: getLabel('products.freeProduct')
    };
    return /*#__PURE__*/ React.createElement(Prices, {
        className: className,
        currency: currency,
        discount: discount,
        orientation: orientation,
        originalPrice: originalPrice,
        totalPrice: totalPrice,
        labels: labels
    });
};

export { PricesContainer, PricesContainer as default };
//# sourceMappingURL=PricesContainer.js.map
